// prettier-ignore
export default "fi"